"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = loadScript;

var _Promise = _interopRequireDefault(require("FileManagerCore/utils/Promise"));

var TIMEOUT = 30000;
var scripts = {};

function loadScript(url) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (scripts[url]) {
    return scripts[url];
  }

  var promise = new _Promise.default(function (resolve, reject) {
    var script = document.createElement('script');
    var timeout = setTimeout(function () {
      handleScriptLoad(Error("Loading " + url + " timed out.")); // eslint-disable-line no-use-before-define
    }, TIMEOUT);

    function handleScriptLoad(event) {
      script.onload = null;
      script.onerror = null;
      clearTimeout(timeout);

      if (event.type === 'error') {
        reject(Error("Script " + url + " could not be loaded."));
      } else {
        resolve();
      }
    }

    script.type = 'text/javascript';
    script.async = true;
    script.timeout = TIMEOUT;
    script.onload = handleScriptLoad;
    script.onerror = handleScriptLoad;
    script.src = url;
    Object.keys(attributes).forEach(function (key) {
      script.setAttribute(key, attributes[key]);
    });
    document.getElementsByTagName('head')[0].appendChild(script);
  });
  scripts[url] = promise;
  return promise;
}

module.exports = exports.default;